{
  "title": "Prijavi se na Platko",
  "signInSubtitle": "Prijavi se na svoj nalog",
  "createAccountTitle": "Kreiraj nalog",
  "createAccountSubtitle": "Kreiraj svoj nalog",
  "alreadyHaveAccount": "Već imaš nalog?",
  "signUpLink": "Prijavi se"
}
